import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Text } from '@vinted/web-ui';
import { getWalletBalance } from 'data/api';
import { getUserId } from 'state/session/selectors';
import { getLocale } from 'state/intl/selectors';
import { formatCurrencyAmount } from 'libs/utils/formatString';
import { transformWalletBalanceDto } from 'data/transformers/wallet';
import { jsx as _jsx } from "react/jsx-runtime";

const CurrentWalletAmount = () => {
  const locale = useSelector(getLocale);
  const currentUserId = useSelector(getUserId);
  const {
    0: balance,
    1: setBalance
  } = useState();
  useEffect(() => {
    const fetchData = async () => {
      if (!currentUserId) return;
      const response = await getWalletBalance(currentUserId);
      if ('errors' in response) return;
      setBalance(transformWalletBalanceDto(response.user_balance));
    };

    fetchData();
  }, [currentUserId]);
  if (!balance) return null;
  const {
    availableAmount
  } = balance;
  return /*#__PURE__*/_jsx(Text, {
    type: Text.Type.Caption,
    text: formatCurrencyAmount(availableAmount, locale)
  });
};

export default CurrentWalletAmount;